import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesDashboardMain } from './modules/ui/Main';

const DashboardPage = (
  <SuspensePage>
    <PagesDashboardMain />
  </SuspensePage>
);

export default DashboardPage;
